export const tableTh = [
  {
    title: '收據號碼',
    class: '',
  },
  {
    title: '收據日期',
    class: 'text-center',
  },
  {
    title: '繳款機關 / 繳款人',
    class: '',
  },
  {
    title: '繳款項目',
    class: '',
  },
  {
    title: '金額',
    class: 'text-center',
  },
  {
    title: '開立機關',
    class: '',
  },
  {
    title: '已作廢',
    class: '',
  },
  {
    title: '功能',
    class: 'text-center',
  },
]

export default {
    tableTh,
  };
